import { PanelSection } from "components/sidebar/sections/InfoPanel";
import ApplyTagsDropdown from "components/tags/ApplyTagsDropdown";
import TagList from "components/TagList";

// A record's tags as a panel section: the icon-only tag dropdown in the title
// applies tags, and the list below shows the applied ones. Callers supply the
// record; the invariant dropdown and list wiring lives here.
// `appliedTags` defaults to the record's own tags; a caller that filters
// disabled tags client-side (revenue opportunities, custom-table rows) passes
// the filtered list instead.
export default function TagsPanelSection({
  title,
  modelType,
  record,
  appliedTags = record?.tags,
  showDisabledTags,
  onUpdate,
  disabled,
  disabledTooltip,
  isLoading = false,
}) {
  return (
    <PanelSection
      title={title}
      isLoading={isLoading}
      action={
        <ApplyTagsDropdown
          modelType={modelType}
          rows={[record]}
          checkedArr={[record?.id]}
          onSuccess={onUpdate}
          showDisabledTags={showDisabledTags}
          disabled={disabled}
          disabledTooltip={disabledTooltip}
          iconOnly
          align="end"
        />
      }
    >
      <TagList
        tags={appliedTags}
        modelType={modelType}
        modelId={record?.id}
        onUpdate={onUpdate}
      />
    </PanelSection>
  );
}
